/* clemoa v4: "Yorum yaz" butonu. Judge.me kuruluysa onun yorum formunu açar; değilse bağlantıya gider. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-c4-write]');
    if (!btn) return;
    var jdgm = document.querySelector('.jdgm-write-rev-link, [data-jdgm-write-review], .jdgm-rev-widg__summary .jdgm-btn');
    if (!jdgm) return;
    e.preventDefault();
    jdgm.click();
    var hedef = document.querySelector('.jdgm-form-wrapper, .jdgm-rev-widg') || jdgm;
    hedef.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
